import { Module } from '@nestjs/common';
import { PersonasModule } from 'src/personas/personas.module';
import { AgentesTransporteController } from './agentes-transporte.controller';
import { AgentesTransporteService } from './agentes-transporte.service';

@Module({
  imports: [PersonasModule],
  controllers: [AgentesTransporteController],
  providers: [AgentesTransporteService],
  exports: [AgentesTransporteService],
})
export class AgentesTransporteModule {}
